import { FileType } from "@/Common/Models/FileType";
import { XComEventDirection } from "./Enums/XComEventDirection";
import { XComEventTypes } from "./Enums/XComEventTypes";
import { XComOptions } from "./Enums/XComOptions";

class XComLogsHelper {
    public static getFileTypeName(p: string): string {
        switch (FileType[p]) {
            case FileType.CONSULTATIONREQUEST:
                return cacheStore.GetString("ConsultationRequestsLabel");
            case FileType.EXAMREQUEST:
                return cacheStore.GetString("ExamRequestsLabel");
            case FileType.ENCOUNTER:
                return cacheStore.GetString("NotesLabel");
            case FileType.MEDICALSUMMARY:
                return cacheStore.GetString("MedicalSummaryLabel");
            case FileType.MEDICATIONSUMMARY:
                return cacheStore.GetString("MedicationSummaryLabel");
            case FileType.RADPDF:
                return cacheStore.GetString("PatientFormLabel");
            case FileType.OBSTETRICALFILE:
                return cacheStore.GetString("ObstetricalFileLabel");
            case FileType.WORKERCLAIM:
                return cacheStore.GetString("WorkerClaimLabel");
            case FileType.WorkSafeBcForm:
                return cacheStore.GetString("FormLabel");
            case FileType.DOCUMENT:
                return cacheStore.GetString("DocumentsLabel");
            case FileType.LABPDF:
                return cacheStore.GetString("LaboratoryLabel");
            case FileType.PatientGrowthChart:
                return cacheStore.GetString("GraphsLabel");
            case FileType.Invoice:
                return cacheStore.GetString("InvoicesLabel");
            default:
                return p;
        }
    }

    public static getEventTypeName(p: string): string {
        switch (XComEventTypes[p]) {
            case XComEventTypes.AccessWithoutConsent:
                return cacheStore.GetString("ConsentAddedLabel");
            case XComEventTypes.DocumentList:
                return cacheStore.GetString("DocumentListLabel");
            case XComEventTypes.FileViewed:
                return cacheStore.GetString("DocumentViewLabel");
            case XComEventTypes.SearchPatient:
                return cacheStore.GetString("PatientSearchLabel");
            default:
                return p;
        }
    }

    public static getEventDirectionName(p: string): string {
        switch (XComEventDirection[p]) {
            case XComEventDirection.Inbound:
                return cacheStore.GetString("InboundLabel");
            case XComEventDirection.OutBound:
                return cacheStore.GetString("OutboundLabel");
            default:
                return p;
        }
    }

    public static getOptionName(p: string): string {
        switch (XComOptions[p]) {
            case XComOptions.OnlyShowAccessWithoutConsent:
                return cacheStore.GetString("OnlyShowAccessWithoutConsentLabel");
            default:
                return p;
        }
    }
}

export { XComLogsHelper };
